export default __webpack_public_path__ + "assets/costa-rica-flag.png";